import { WhitelabelConfig } from '@whitelabel/types';

const JtbWhitelabelConfig: WhitelabelConfig = {
    displayName: 'JTB',
    termsOfUseUrl: 'https://www.jtb.co.jp/myjtb/kiyaku',
    privacyPolicyUrl: 'https://www.jtbcorp.jp/jp/privacy/jtb',
};

export default JtbWhitelabelConfig;
